import { Component, computed, input } from '@angular/core';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

const ICON_MAP: Record<string, string> = {
    'nexcore_rental_resourceAssignmenmt_out': 'assets/NC_Icon_Ressource-Out_18.svg',
    'nexcore_rental_resourceAssignmenmt_in': 'assets/NC_Icon_Ressource-In_18.svg',
    'nexcore_rental_resourceAssignmenmt_refuel': 'assets/NC_Icon_Refuel_18.svg',
    'nexcore_rental_resourceAssignmenmt_review': 'assets/NC_Icon_Examine_18.svg',
    'nexcore_operated_rental_task': 'assets/NC_Icon_Operate_18.svg',
    'nexcore_default_task': 'assets/NC_Icon_Task-Open_18.svg',
    'nexcore_damage_assess_task': 'assets/NC_Icon_Issue-Check_18.svg',
    'nexcore_damage_resolve_task': 'assets/NC_Icon_Ressource-Damage-Repair_18.svg',
    'icon-ticket': 'assets/NC_Icon_Issue-General_18.svg',
};

const DEFAULT_ICON = 'assets/NC_Icon_Issue-General_18.svg';

@Component({
    selector: 'app-task-type-icon',
    template: `
        <img [pTooltip]="task()?.taskType?.name" tooltipPosition="bottom" [src]="iconSrc()" [alt]="task()?.type ?? 'Task'" class="task-icon" [style.width.px]="size()" [style.height.px]="size()" draggable="false">
    `,
    styles: [`
        .task-icon {
            display: block;
            vertical-align: top;
        }
    `]
})
export class TaskTypeIconComponent {
    readonly task = input<Task>();
    readonly size = input<number>(18);

    readonly iconSrc = computed(() => {
        const type = this.task()?.type;
        return type ? (ICON_MAP[type] ?? DEFAULT_ICON) : DEFAULT_ICON;
    });
}
